import { render, staticRenderFns } from "./EmailHistory.vue?vue&type=template&id=5ebf4b13&scoped=true"
import script from "./EmailHistory.vue?vue&type=script&lang=ts"
export * from "./EmailHistory.vue?vue&type=script&lang=ts"
import style0 from "./EmailHistory.vue?vue&type=style&index=0&id=5ebf4b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf4b13",
  null
  
)

export default component.exports